<template>
  <div @click.stop class="claim-history-container">
    <div class="claim-history-header">
      <svg
        @click="goBack"
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="16"
        viewBox="0 0 9 16"
        fill="none"
      >
        <path
          d="M8.59546 15.7534C8.92432 15.4245 8.92432 14.8913 8.59546 14.5624L2.03302 8L8.59546 1.43756C8.92432 1.1087 8.92432 0.57551 8.59546 0.246646C8.2666 -0.0822163 7.7334 -0.0822163 7.40454 0.246646L0.246647 7.40454C-0.0822157 7.7334 -0.0822157 8.2666 0.246647 8.59546L7.40454 15.7534C7.7334 16.0822 8.2666 16.0822 8.59546 15.7534Z"
          fill="#101010"
          fill-opacity="0.9"
        />
      </svg>
      <span>历史领取</span>
    </div>
    <div v-for="item in claimHistoryList" :key="item.id" class="claim-history-content">
      <h2>{{ item.activityName }}</h2>
      <div
        v-for="reward in item.task"
        :key="reward.taskId"
        @click="handleProductClick(reward.product[0])"
        class="claim-history-content-item"
      >
        <div class="claim-history-content-item-left">
          <div v-if="reward.condition" class="claim-history-content-item-left-title">
            {{ reward.condition }}
          </div>
          <div v-if="reward.reward" class="claim-history-content-item-left-content">
            {{ reward.reward }}
          </div>
          <div
            v-if="reward.product[0]?.rewardReceiveTime"
            class="claim-history-content-item-left-time"
          >
            {{ reward.product[0]?.rewardReceiveTime }}
          </div>
        </div>
        <img :src="reward.product[0]?.imageUrls[0]" alt="ticket" />
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import _fetch from '@/utils/fetch'
  import { goShopPages } from '../../util'
  defineOptions({ name: 'AppClaimHistory' })
  const emit = defineEmits(['closeClaimHistory'])

  const goBack = () => {
    emit('closeClaimHistory')
  }

  const claimHistoryList = ref([])
  const initClaimHistory = async () => {
    const response = await _fetch('/aigc/api/activity/want-it/reward/list', {
      method: 'GET',
      params: {
        claimed: true
      }
    })
    const res = await response.json()
    if (res.code === 200) {
      claimHistoryList.value = res.data.activity
      console.log('claimHistoryList', claimHistoryList.value)
    }
  }

  const handleProductClick = product => {
    goShopPages(`/order/detail/${product.orderId}?from=want_task_page`, 'new')
  }

  onMounted(() => {
    initClaimHistory()
  })
</script>

<style scoped lang="stylus">
  @import './index.styl'
</style>
